export default __webpack_public_path__ + "static/media/icn-megaphone-plus.5c87fe75.svg";